// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2LOJ5","title":"FrontImage_title__os1xB"};